import { useDispatch } from "react-redux";
import useInput from "../../Hooks/use-form";
import { updateUser } from "../../Redux/apiCalls";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Btn,
  Container,
  Form,
  FormWrapper,
  Input,
  InputContainer,
  InputTitle,
  Option,
  P,
  ResetButton,
  Select,
  Span,
  TextArea,
  TextTitle,
  Title,
} from "./information.styles";
import { useNavigate } from "react-router-dom";

const Information = ({ users, isFetching }) => {

  console.log(users);

  const { value: enteredUsername, valueChangeHandler: usernameInputChange } =
    useInput(users?.full_name || "");

  const { value: enteredCompany, valueChangeHandler: companyInputChange } =
    useInput(users?.company_name || "");

  const { value: enteredBvn, valueChangeHandler: bvnInputChange } = useInput(
    users?.bvn || ""
  );

  const { value: enteredEmail, valueChangeHandler: emailInputChange } =
    useInput(users?.email || "");

  const { value: enteredPhone, valueChangeHandler: phoneInputChange } =
    useInput(users?.phoneno || "");

  const { value: enteredAddress, valueChangeHandler: addressInputChange } =
    useInput(users?.address || "");

  const { value: enteredTarget, valueChangeHandler: targetInputChange } =
    useInput(users?.target || "");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFormSubmission = (e) => {
    e.preventDefault();
    updateUser(dispatch, {
      id: users.id,
      full_name: enteredUsername,
      company_name: enteredCompany,
      bvn: enteredBvn,
      email: enteredEmail,
      phoneno: enteredPhone,
      address: enteredAddress,
      target: enteredTarget,
    });
    toast.success("Changes made successfully");
    setTimeout(() => navigate(`/profile/${users.user_name}`), 1000);
  };

  return (
    <Container>
      <Title>User Information</Title>
      <P>
        Edit User information <Span>below</Span>
      </P>
      <ToastContainer />
      <FormWrapper onSubmit={handleFormSubmission}>
        <Form>
          <InputContainer>
            <InputTitle>Full Name</InputTitle>
            <Input
              type="text"
              onChange={usernameInputChange}
              value={enteredUsername}
            />
          </InputContainer>
          <InputContainer>
            <InputTitle>Business Name</InputTitle>
            <Input
              type="text"
              onChange={companyInputChange}
              value={enteredCompany}
            />
          </InputContainer>
          <InputContainer>
            <InputTitle>BVN</InputTitle>
            <Input type="text" onChange={bvnInputChange} value={enteredBvn} />
          </InputContainer>
          <InputContainer>
            <InputTitle>Email</InputTitle>
            <Input
              type="email"
              onChange={emailInputChange}
              value={enteredEmail}
            />
          </InputContainer>
          <InputContainer>
            <InputTitle>Phone Number</InputTitle>
            <Input
              type="text"
              onChange={phoneInputChange}
              value={enteredPhone}
            />
          </InputContainer>
          <InputContainer>
            <InputTitle>Status</InputTitle>
            <Select name="status">
              <Option value={users?.status}>{users?.status}</Option>
              <Option value="superadmin">Superadmin</Option>
              <Option value="client">Client</Option>
              <Option value="reseller">Reseller</Option>
              <Option value="admin">Admin</Option>
            </Select>
          </InputContainer>
          <InputContainer>
            <InputTitle>Address</InputTitle>
            <Input
              type="text"
              onChange={addressInputChange}
              value={enteredAddress}
            />
          </InputContainer>
          <InputContainer>
            <TextTitle>Target</TextTitle>
            <TextArea onChange={targetInputChange} value={enteredTarget} />
          </InputContainer>
        </Form>
        <Btn type="submit">{isFetching ? "Updating" : "Update Profile"}</Btn>
        <ResetButton>
          <Btn>Password Reset</Btn>
          <Btn>Pin Reset</Btn>
        </ResetButton>
      </FormWrapper>
    </Container>
  );
};

export default Information;
